import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal, { modalStyles as m } from "./Modal";
import { applyCustomDiscount, clearOrderDiscount } from "../../../Redux/features/WebRegister/cartSlice";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import NumericInput from "../NumericInput";

// Order-level custom discount ($ or %).
export default function CustomDiscountModal({ onClose }) {
  const dispatch = useDispatch();
  const { totals, couponTotal, customTotal, orderPercentDiscount } = useSelector((st) => st.webRegisterCart);
  const [value, setValue] = useState(0);
  const [isPercent, setIsPercent] = useState(false);
  // Android setupPercentageDialog: an order-level $ discount must be LESS THAN
  // mSubTotal − getTotalDiscountAmount() (EVERY discount already applied — discounts stack).
  const discountable = Math.max((Number(totals.subtotal) || 0) - (Number(couponTotal) || 0) - (Number(customTotal) || 0), 0);

  const apply = () => {
    const v = Number(value) || 0;
    if (isPercent) {
      // Android: percent must be > 0 and < 101; only ONE % discount per order (isSplitPaymentDiscountHasPercentage).
      if (!(v > 0 && v < 101)) return ToastifyAlert("Enter a valid percentage", "error");
      if (Number(orderPercentDiscount) > 0) return ToastifyAlert("Percentage discount is already applied.", "error");
    } else if (!(v > 0 && v < discountable)) {
      return ToastifyAlert(v > 0 ? "Amount should be less than the subtotal" : "Please enter a valid amount", "error");
    }
    dispatch(applyCustomDiscount({ value: v, isPercent }));
    onClose();
  };

  return (
    <Modal title="Order discount" onClose={onClose}>
      <div style={m.toggleRow}>
        <button style={m.toggle(!isPercent)} onClick={() => setIsPercent(false)}>Amount ($)</button>
        <button style={m.toggle(isPercent)} onClick={() => setIsPercent(true)}>Percent (%)</button>
      </div>
      <div style={{ ...m.label, marginTop: 12 }}>{isPercent ? "Percent off" : "Amount off"}</div>
      <NumericInput style={m.input} value={value} onChange={setValue} decimals={2} max={isPercent ? 100 : undefined} onEnter={apply} autoFocus />
      <button style={m.primary} onClick={apply}>Apply discount</button>
      <button style={m.ghost} onClick={() => { dispatch(clearOrderDiscount()); onClose(); }}>Remove discount</button>
    </Modal>
  );
}
